import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import * as S from './styled'

const GuidelineDownload = ({ i18nKey, href, fullWidth }) => {
  const { t } = useTranslation()

  return (
    <S.Container fullWidth={fullWidth}>
      <S.LightbulbIcon alt="" />

      <S.Text>
        <Trans
          t={t}
          i18nKey={i18nKey}
          components={[
            <a key="0" href={href} target="_blank" rel="noopener noreferrer">
              {t('download')}
            </a>,
          ]}
        />
      </S.Text>
    </S.Container>
  )
}

export default GuidelineDownload
